<template>
    <div class="mylistwrap" v-if="isload">
        <div v-if="$common.basic.isarrayexist(infolist)" class="mylist">
            <dl class="avg listheader" v-if="!issmall">
                <dd v-if="istea&&!isviewstu">{{$common.dicword('learner')}}</dd>
                <dd>{{$common.dicword('course')}}</dd>
                <dd>{{$common.dicword('testpaper')}}</dd>
                <dd>{{$common.dicword('timeend')}}</dd>
                <dd v-if="!istutor">{{$common.dicword('teststat9')}}</dd>
                <dd>{{$common.dicword('grade')}}</dd>
            </dl>
            <div class="listinfo">
                <dl class="avg" v-for="item in infolist" :key="item.id">
                    <dd v-if="istutor">
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('learner',true)}}&nbsp;
                        </span>
                        {{item.username}}
                    </dd>
                    <dd v-else-if="isct&&!isviewstu">
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('learner',true)}}&nbsp;
                        </span><ffmember :username="item.username" :stuid="item.mid"></ffmember>
                    </dd>

                    <dd>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('course',true)}}&nbsp;
                        </span><router-link class="overparent" :to="item.x_course.x_root+item.x_course.id" :title="$common.langinfo(item.x_course.title,item.x_course.title_en)"><ffoverdot :title="item.x_course.title" :title_en="item.x_course.title_en" :needtitle="false"></ffoverdot></router-link>
                    </dd>

                    <dd>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('testpaper',true)}}&nbsp;
                        </span>
                        <a href="#" class="overparent" @click="showquiz(item.id)" :title="item.papertitle"><ffoverdot :title="item.papertitle" :needtitle="false"></ffoverdot></a>
                    </dd>

                    <dd>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('timeend',true)}}&nbsp;
                        </span>{{$common.basic.dateformat(item.timeend,'yyyy-MM-dd hh:mm')}}
                    </dd>

                    <dd v-if="!istutor">
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('teststat9',true)}}&nbsp;
                        </span>{{$common.chint2bool(item.isjudge)}}
                    </dd>

                    <dd>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('grade',true)}}&nbsp;
                        </span>{{item.grade}}
                    </dd>



                </dl>
            </div>

            <div class="ffpage" v-if="istea">
                <el-pagination :small="issmall" v-if="res.recordcount>res.ps" :background="true" :current-page.sync="res.cpage" :page-size="res.ps" layout=" prev, pager, next" :total="res.recordcount" @current-change="getdata">
                </el-pagination>
            </div>
        </div>


        <div class="memnorecord" v-else>{{$common.dicword('norecord')}}</div>
        <el-dialog v-if="isshowinfo" :visible.sync="isshowinfo" top="0px" class="mydialog2 modulewrap" append-to-body :show-close="!isreview" :close-on-click-modal="!isreview" :close-on-press-escape="!isreview">
            <div class="mydialogwrap">
                <div class="ssqswrap">
                    <myScroll class="scroll">
                        <div class="ssqs">
                            <div class="ssqsoption">
                                <span class="quizinfo">{{$common.dicword('learner',true)}}{{infocur.username}}</span>
                                <span class="quizinfo" v-if="!isreview">{{$common.dicword('course',true)}}{{$common.langinfo(c_infocur.x_course.title,c_infocur.x_course.title_en)}}</span>
                                <span class="quizinfo">{{$common.dicword('testpaper',true)}}{{infocur.papertitle}}</span>
                                <span class="quizinfo" v-if="!isreview">{{$common.dicword('timebegin',true)}}{{$common.basic.dateformat(infocur.timebegin,'yyyy-MM-dd hh:mm')}}</span>
                                <span class="quizinfo">{{$common.dicword('timeend',true)}}{{$common.basic.dateformat(infocur.timeend,'yyyy-MM-dd hh:mm')}}</span>
                                <span class="quizinfo" v-if="infocur.isjudge && infocur.teaname && isct">{{$common.dicword('coursementor',true)}}{{infocur.teaname}}</span>
                                <span class="quizinfo" v-if="!isreview"> {{$common.dicword('grade',true)}}{{infocur.grade}}/{{info.total}}</span>
                            </div>
                            <div class="ssexampaper">
                                <div class="exampart" v-if="isreview?(item.qtkv==5||item.qtkv==6):true" v-for="item in info.questionsetting" :key="item.id" v-viewer>
                                    <dl class="exampartinfo">
                                        <dt>{{item.x_title}} &nbsp; <span v-html="item.title"></span> &nbsp; ({{$common.dicword('questioncount')}}: &nbsp; {{item.usc}} &nbsp; {{$common.dicword('questionscore')}}: &nbsp; {{item.score}})</dt>
                                        <dd><span v-html="item.condesc"></span></dd>
                                    </dl>

                                    <div class="examquestion" v-for="item2 in item.questionlist" :key="item2.id">
                                        <div class="stem">
                                            {{item2.x_title}}&nbsp;
                                            <div class="stemhtml" v-if="item.qtkv==2||item.qtkv==3">

                                                <span v-html="item2.stem1">
                                                </span>
                                                <span class="inputline">
                                                    {{item2.x_option+'('+item2.x_right+')'}}
                                                </span>
                                                <span v-html="item2.stem2">
                                                </span>
                                            </div>
                                            <template v-else>
                                                <span v-html="item2.constem"></span>
                                            </template>
                                        </div>
                                        <template v-if="item.qtkv==1">
                                            <dl v-for="(item3,index3) in item2.conoptions" :key="item3.id">
                                                <dt>
                                                    <el-radio v-model="item2.x_option" :label="item3.id.toString()">
                                                        {{$common.basic.chint2letter(index3)}}
                                                    </el-radio>
                                                </dt>
                                                <dd :class="{rightoption:Number(item2.x_right)==item3.id}" v-html="item3.conoption"></dd>
                                            </dl>
                                        </template>

                                        <div v-else-if="item.qtkv==4">
                                            <el-radio-group v-model="item2.x_option" class="qtradio">
                                                <el-radio label="1"><span :class="{rightoption:item2.x_right==1}">True</span></el-radio>
                                                <el-radio label="2"><span :class="{rightoption:item2.x_right==2}">False</span></el-radio>
                                                <el-radio label="3"><span :class="{rightoption:item2.x_right==3}">NOT GIVEN</span></el-radio>
                                            </el-radio-group>
                                        </div>
                                        <div v-else-if="item.qtkv==5||item.qtkv==6" class="qwriting">
                                            <span v-html="item2.x_option"></span>

                                            <div class="ffuploadimg">
                                                <div v-for="(item,index) in item2.x_imgs" :key="index" class="imgitem" v-if="$common.basic.isarrayexist(item2.x_imgs)">
                                                    <div class="imgitembox">
                                                        <img :src="item" />

                                                    </div>

                                                </div>
                                            </div>

                                            <div v-if="c_options.tk>1 && c_options.isdone==0 && !item2.x_issave" class="writingfeedwrap">
                                                <el-input type="textarea" :rows="5" :placeholder="$common.dicword('feedback')" v-model="item2.x_right"></el-input>

                                                <div class="writingfeed">
                                                    <el-input type="text" style="width:100px;" :placeholder="$common.dicword('score')" maxlength="10" size="mini" v-model="item2.x_score"></el-input>
                                                    <div class="writingfeedbtn">
                                                        <el-button type="primary" size="mini" class="btnmain" @click="quizmark(item2,item.score)">{{$common.dicword('save')}}</el-button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else class="writingfeedwrap">
                                                <span class="writingfeedright" v-html="item2.x_right"></span>
                                                {{$common.dicword('score',true)}}{{item2.x_score}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </myScroll>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { mixinsubpage } from "@/mixin/mixin";
    export default {
        name: 'Cquiz',
        mixins: [mixinsubpage],
        components: {
            Ccourseinfo: () => import('@/components/Ccourseinfo')
        },
        data() {
            return {
                postact: 'tc_mem_quiz',
                isshowinfo: false,
                infocur: {},
                info: {}
            };
        },
        computed: {
            c_infocur: function () {
                return this.$common.basic.fffind(this.infolist, 'id', this.infocur.id);
            },
            isreview: function () {
                return this.istutor && !this.c_options.isdone;
            }
        },
        methods: {
            getdata: function () {
                this.$common.post(this.postjson, res => {
                    this.$common.each(res.infodatacourse, (item) => {
                        item.x_root = this.$common.tranlearnfolder(item.typekv);
                    });
                    this.$common.each(res.infodata, item => {
                        item.x_course = this.$common.basic.fffind(res.infodatacourse, 'id', item.courseid);
                    });
                    this.infolist = res.infodata;
                    this.res = res;

                    this.isload = true;

                    if (this.isreview) {
                        if (this.$common.basic.isobjexist(res.infodataread)) {
                            this.showquiz(res.infodataread.id);
                        }
                    }
                });
            },

            showquiz: function (v) {
                let jsondata = {
                    'postdata': { 'act': 'tc_mem_quizdetail', 'id': v, 'data': { 'tk': this.c_options.tk, 'isdone': this.c_options.isdone } }, 'msg': ''
                };
                this.$common.post(jsondata, res => {
                    this.infocur = res.infodata;

                    let _info = this.$common.basic.ffjsonparse(this.infocur.conpaper);
                    let _answer = this.$common.basic.ffjsonparse(this.infocur.conreply);
                    if (this.$common.basic.isobjexist(_info)) {
                        this.$common.each(_info.questionsetting, (item, index) => {
                            item.x_title = this.$common.basic.tranroman(index + 1) + ' ';
                            if (!item.qtkv) { item.qtkv = 1; }

                            this.$common.each(item.questionlist, (item2, index2) => {
                                item2.x_title = (index2 + 1) + '.';

                                let stem1 = '';
                                let stem2 = '';

                                if (item2.constem) {
                                    if (item2.constem.indexOf('#LINE#') >= 0) {
                                        let stems = item2.constem.split('#LINE#');
                                        stem1 = stems[0];
                                        stem2 = stems[1];
                                    }
                                    else {
                                        stem1 = item2.constem;
                                    }
                                }

                                item2.stem1 = stem1;
                                item2.stem2 = stem2;

                                item2.constem = this.$common.basic.ffinputline(item2.constem);


                                item2.conoptions = item.qtkv == 1 ? JSON.parse(item2.conoptions) : item2.conoptions;

                                let canswer = this.$common.basic.fffind(_answer, 'id', item2.id);
                                item2.x_option = canswer.selectoption;
                                item2.x_right = this.isjudge ? canswer.rightoption : this.$common.basic.strunformatline(canswer.rightoption);
                                item2.x_score = canswer.score;
                                item2.x_issave = false;
                                item2.x_imgs = canswer.attach ? canswer.attach.split(',') : [];
                                if (item2.x_score < 0) {
                                    item2.x_score = 0;
                                }
                            });
                        });
                    }
                    this.info = _info;

                    this.isshowinfo = true;
                });
            },
            quizmark: function (v, maxscore) {
                let score = this.$common.basic.chstr2int(v.x_score);
                if (score >= 0 && score <= maxscore) {
                    let jsondata = { 'postdata': { 'act': 'tc_mem_quizmark', 'data': { "recordid": this.infocur.id, "answerid": v.id, 'answerscore': score, 'mark': v.x_right } }, 'msg': '' };
                    this.$common.post(jsondata, res => {
                        v.x_issave = true;
                        if (res.isjudge) {
                            this.isshowinfo = false;
                            this.getdata();
                        }
                    });
                }
                else {
                    this.$common.alert(this.$common.dicword('scorerange', true) + '0-' + maxscore);
                }
            }
        }
    }
</script>

<style scoped>
    .ssqswrap { width: 100%; padding: 20px; height: 100%; flex-flow: column nowrap }
    .ssqs { width: 100%; padding: 20px; flex-flow: column nowrap }
        .ssqs .ssqsoption { width: 100%; align-items: center; flex-flow: row wrap; font-size: 16px; font-weight: bold }
            .ssqs .ssqsoption .quizinfo { display: inline-block; margin-right: 20px; margin-bottom: 10px; }

        .ssqs .ssexampaper { width: 100%; flex-flow: column nowrap; padding-top: 20px; }
            .ssqs .ssexampaper .exampart { width: 100%; padding-bottom: 20px; flex-flow: column nowrap; }
                .ssqs .ssexampaper .exampart .exampartinfo { width: 100%; flex-flow: column nowrap; padding-bottom: 10px; padding-top: 10px; }
                    .ssqs .ssexampaper .exampart .exampartinfo dt { width: 100%; font-size: 16px; }
                    .ssqs .ssexampaper .exampart .exampartinfo dd { width: 100%; font-size: 14px; padding-left: 25px; padding-top: 5px; }
                .ssqs .ssexampaper .exampart .examquestion { width: 100%; padding-left: 25px; flex-flow: column nowrap; padding-bottom: 10px; }
                    .ssqs .ssexampaper .exampart .examquestion .stem { width: 100%; flex-flow: row nowrap; padding-bottom: 10px; line-height: 30px; }
                        .ssqs .ssexampaper .exampart .examquestion .stem .stemhtml { display: block; }
                            .ssqs .ssexampaper .exampart .examquestion .stem .stemhtml span > p:first-child { display: inline }
                    .ssqs .ssexampaper .exampart .examquestion dl { width: 100%; flex-flow: row nowrap; padding-bottom: 5px; align-items: baseline }
                        .ssqs .ssexampaper .exampart .examquestion dl dt { width: 50px; flex: none }
                    .ssqs .ssexampaper .exampart .examquestion .rightoption { background-color: #0f8609; color: #FFF }

                    .ssqs .ssexampaper .exampart .examquestion .qwriting { width: 100%; flex-flow: column nowrap }
                    .ssqs .ssexampaper .exampart .examquestion .writingfeedwrap { width: 100%; max-width: 500px; flex-flow: column nowrap; padding-top: 20px; }
                    .ssqs .ssexampaper .exampart .examquestion .writingfeed { width: 250px; flex-flow: row nowrap; align-content: center; margin-top: 20px; align-items: center }
                        .ssqs .ssexampaper .exampart .examquestion .writingfeed .writingfeedbtn { justify-content: center; margin-left: 10px; }
                    .ssqs .ssexampaper .exampart .examquestion .writingfeedwrap .writingfeedright { width: 100%; display: block; padding-bottom: 20px; }
</style>
